import React from "react";
import {
  getBuyGetText,
  getProductCopy,
  isBuyOrGet,
} from "../../../../../../../../../../types/product/ibrief-product/ibrief-product.functions";
import {
  HostContainer,
  ProductBuyGetLabel,
  ProductCopy,
  ProductSku,
  ProductTitle,
} from "./flyer-detail-page-preview-position-details-product.styles";
import { FlyerDetailPagePreviewPositionDetailsProductProps } from "./flyer-detail-page-preview-position-details-product.props";

export const FlyerDetailPageTemplatePositionDetailsProduct = (
  props: FlyerDetailPagePreviewPositionDetailsProductProps
) => {
  const isProductActive = () => (!Boolean(props.flyerEndDatePassed) ? props.product.active : true);

  return (
    <HostContainer>
      <ProductTitle active={isProductActive()}>
        <ProductBuyGetLabel showIf={isBuyOrGet(props.product.buyGetStatus)}>
          {getBuyGetText(props.product.buyGetStatus)}
        </ProductBuyGetLabel>
        {props.product.name}
        <ProductSku>{props.product.sku}</ProductSku>
      </ProductTitle>
      <ProductCopy>{getProductCopy(props.product, props.copy, props.language)}</ProductCopy>
    </HostContainer>
  );
};
